/**
 * Placeholder Pages
 * Features to be fully implemented
 */

import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { 
  ArrowLeft, Construction,
  FileAudio, Layout, Languages
} from 'lucide-react';

const PlaceholderPage = ({ title, icon: Icon, description, backLink = '/' }) => (
  <div className="space-y-6">
    <div className="flex items-center gap-4">
      <Link to={backLink} className="text-gray-400 hover:text-gray-600">
        <ArrowLeft className="w-5 h-5" />
      </Link>
      <div>
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
    </div>
    
    <div className="bg-white rounded-lg shadow p-12 text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 mb-4">
        {Icon && <Icon className="w-8 h-8 text-amber-600" />}
      </div>
      <div className="flex items-center justify-center gap-2 text-amber-600 mb-4">
        <Construction className="w-5 h-5" />
        <span className="font-medium">Under Development</span>
      </div>
      <p className="text-gray-500 max-w-md mx-auto">
        This feature is coming soon. The full implementation will include
        visual builders, real-time preview, and multi-language support.
      </p>
    </div>
  </div>
);

// IVR Pages - Placeholders
export const SegmentsList = () => {
  const { agentId } = useParams();
  return (
    <PlaceholderPage 
      title="Audio Segments"
      icon={FileAudio}
      description="Manage reusable audio segments for your IVR responses"
      backLink={`/agents/${agentId}/ivr`}
    />
  );
};

export const TemplatesList = () => {
  const { agentId } = useParams();
  return (
    <PlaceholderPage 
      title="Dynamic Templates"
      icon={Layout}
      description="Create audio templates with variable substitution"
      backLink={`/agents/${agentId}/ivr`}
    />
  );
};

export const TemplateBuilder = () => {
  const { agentId } = useParams();
  return (
    <PlaceholderPage 
      title="Template Builder"
      icon={Layout}
      description="Build dynamic audio templates with segments and variables"
      backLink={`/agents/${agentId}/ivr/templates`}
    />
  );
};

export const LanguageSettings = () => {
  const { agentId } = useParams();
  return (
    <PlaceholderPage 
      title="Language Settings"
      icon={Languages}
      description="Configure multi-language support and audio coverage"
      backLink={`/agents/${agentId}/ivr`}
    />
  );
};
